<template>
  <div class="map-container">
    <div ref="mapEl" class="map"></div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'

const API_KEY = 'AIzaSyCngQmFI-QEa_MMgxBucUOkuu_u70PwdX0'

let loadPromise = null
function loadGoogleMaps() {
  if (window.google && window.google.maps) return Promise.resolve()
  if (loadPromise) return loadPromise

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}`
    script.async = true
    script.defer = true
    script.onload = resolve
    script.onerror = () => reject(new Error('Failed to load Google Maps'))
    document.head.appendChild(script)
  })
  return loadPromise
}

export default {
  props: {
    lat: { type: Number, required: true },
    lng: { type: Number, required: true }
  },

  setup(props) {
    const mapEl = ref(null)
    let map = null
    let marker = null

    const initMap = async () => {
      await loadGoogleMaps()

      const position = { lat: props.lat, lng: props.lng }

      map = new google.maps.Map(mapEl.value, {
        center: position,
        zoom: 10,
        mapTypeId: 'terrain'
      })

      marker = new google.maps.Marker({
        position,
        map,
        title: 'Adventure location'
      })
    }

    onMounted(initMap)

    watch(() => [props.lat, props.lng], ([lat, lng]) => {
      if (map && marker) {
        const position = { lat, lng }
        map.setCenter(position)
        marker.setPosition(position)
      }
    })

    return { mapEl }
  }
}
</script>

<style scoped>
  .map-container {
    margin: 20px 0;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #cccccc;
  }
  .map {
    width: 100%;
    height: 350px;
  }
</style>
